export default __webpack_public_path__ + "6ed55d6c016f38e5b849e01da4ab5545.png";